<template>
  <div class="vx-row">
    <vs-card>
      <div slot="header">
        <h5>Statistique des demandes</h5>
      </div>
      <vs-row>
        <vs-col>
          <div class="flex -mx-2">
            <div class="w-1/4 px-2">
              <vs-select v-model="user"
                         placeholder="Selectionner"
                         class="w-full"
                         label="Chargé clientelle"
                         label-placeholder="Selectionner"
                         autocomplete
              >
                <vs-select-item key="02" value="0" text="Tout"/>
                <vs-select-item :key="index" :value="item.id" :text="item.name +' '+ item.first_name"
                                v-for="(item,index) in charger"/>
              </vs-select>
            </div>
            <div class="w-1/4 px-2">
              <vs-select
                v-model="category"
                placeholder="Selectionner"
                class="w-full"
                label="Type de demande"
                label-placeholder="Selectionner"
                autocomplete
              >
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in categories"/>
              </vs-select>
            </div>
            <div class="w-1/4 px-2">
              <span class="vs-select--label">Période</span>
              <date-range-picker
                ref="picker"
                :opens="opens"
                :locale-data=locale
                :singleDatePicker="false"
                :timePicker=false
                :showWeekNumbers="showWeekNumbers"
                :showDropdowns="showDropdowns"
                :autoApply="autoApply"
                v-model="dateRange"
                :ranges=false
                @update="updateValues"
                :linkedCalendars="linkedCalendars"
                :dateFormat="dateFormat"
                :always-show-calendars="false"
                :alwaysShowCalendars="alwaysShowCalendars"
                class="vs-inputx vs-input--input"
              >
                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                  {{ picker.startDate | date }} - {{ picker.endDate | date }}
                </div>
              </date-range-picker>
            </div>
            <div class="w-1/8 px-2">
              <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''" @click="getStat(), getStatInfo(), getRequest(page)" style="margin-top: 18px;" color="primary"
                         type="filled" icon="search" size="small">Recherche
              </vs-button>
            </div>
            <div class="w-1/8 px-2">
              <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''" @click="exportStats()" style="margin-top: 18px;" color="primary" type="border"
                         icon="cloud_download" size="small"> Exporter
              </vs-button>
            </div>
          </div>
        </vs-col>
      </vs-row>
      <vs-divider></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-2/3">
          <template>
            <vue-apex-charts v-if="!loading" type="bar" height="350" :options="columnChart.chartOptions"
                             :series="columnChart.series"></vue-apex-charts>
          </template>
        </div>
        <div class="vx-col w-full lg:w-1/3">
          <div>
            <h4>Demande reçus</h4>
            <h4>{{ stats.totalRequestReceived ? stats.totalRequestReceived : 0 }}</h4>
          </div>
          <vs-divider></vs-divider>
          <div>
            <h4>Demande traitées</h4>
            <h4>{{ stats.totalRequestTreat ? stats.totalRequestTreat : 0 }}</h4>
          </div>
          <vs-divider></vs-divider>
          <div>
            <h4>Demande non traitées</h4>
            <h4>{{ stats.totalRequestOnTreat ? stats.totalRequestOnTreat : 0 }}</h4>
          </div>
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-table
            ref="table"
            max-items="10"
            search
            :data="requests"
          >
            <template slot="thead">
              <vs-th width="20%" sort-key="title">Demande</vs-th>
              <vs-th width="20%" sort-key="type">Type</vs-th>
              <vs-th width="20%" sort-key="status">Statut</vs-th>
              <vs-th width="10%" sort-key="priority">Priorité</vs-th>
              <vs-th width="5%" sort-key="group">Envoyé par</vs-th>
              <vs-th width="15%" sort-key="created_at">Date</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span class="">{{ tr.title }} </span>
                  <vs-chip v-if="tr.fromEmail">Email</vs-chip>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.type | title }}</p>
                </vs-td>

                <vs-td>
                  <vs-chip>{{ tr.status | title}}</vs-chip>
                </vs-td>

                <vs-td>
                  <vs-chip
                    :color="getPriorityColor(tr.priority)"
                    class="product-order-status"
                  >{{ tr.priority | title }}
                  </vs-chip
                  >
                </vs-td>

                <vs-td>
                  <p class="group">{{ tr.group }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-price">{{ tr.created_at | title }}</p>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
        </div>
      </div>
    </vs-card>
  </div>
</template>
<script>
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import VueApexCharts from 'vue-apexcharts'
  import moment from "moment";
  import axios from "axios";

  export default {
    name: "manager",
    components: {DateRangePicker, VueApexCharts},
    data: () => ({
      charger: [],
      categories: [],
      user: 0,
      category: '',
      stats: [],
      requests: [],
      last_page: null,
      page: 1,
      opens: 'center',
      showWeekNumbers: true,
      linkedCalendars: true,
      alwaysShowCalendars: true,
      showDropdowns: true,
      autoApply: false,
      locale: {
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: 'Appliquer',
        cancelLabel: 'Annuler',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 0
      },
      dateRange: {
        startDate: "",
        endDate: "",
      },
      columnChart: {
        series: [],
        chartOptions: {
          colors: ['#008FFA', '#067A2F', '#FF0003', '#FF9F43', '#FFCC00'],
          plotOptions: {
            bar: {
              horizontal: false,
              //endingShape: 'rounded',
              columnWidth: '55%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },

          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'Nombres'
            }
          },
          fill: {
            opacity: 1

          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Nombres " + val
              }
            }
          }
        }
      },
      loading: false
    }),
    watch: {
      page(value) {
        this.getRequest(value);
      },
    },
    mounted() {
      this.getCharger()
      this.getCategories()
    },
    methods: {
      _buildQuery(params) {
        let string = ''

        for (let key in params) {
          if (params[key] !== "" && params[key] !== undefined && params[key] !== null) {
            string += `${key}=${params[key]}&`
          }
        }
        string = '?' + string.substring(0, string.length - 1)
        return string;
      },
      getPriorityColor(status) {
        status = status.toLowerCase();
        if (status == "normale") return "primary";
        if (status == "basse") return "success";
        if (status == "haute") return "danger";
        return "primary";
      },
      updateValues(values) {
        this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
        this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
      },
      dateFormat(classes, date) {
        let yesterday = moment().subtract(1, 'day');
        if (!classes.disabled) {
          //classes.disabled = moment(date).isSame(yesterday, 'day')
        }
        return classes
      },
      getCharger() {
        this.$vs.loading()
        this.$http.get('/users?profile=3&paginate=0').then((response) => {
          this.charger = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          console.log(error)
        })
      },
      getCategories() {
        this.$http.get('/categories-requests?paginate=0').then((response) => {
          this.categories = response.data
        }).catch((error) => {
          console.log(error)
        })
      },
      getStatInfo() {
        let info = {
          type: this.category,
          user: this.user,
          date_begin: this.dateRange.startDate,
          date_end: this.dateRange.endDate
        }
        this.$http.get('/statistics/manager' + this._buildQuery(info)).then((response) => {
          this.stats = response.data
        }).catch((error) => {
          console.log(error)
        })
      },
      getStat() {
        this.loading = true;
        this.$vs.loading()
        this.columnChart.chartOptions.xaxis.categories = []
        this.columnChart.series = []
        this.$http.post('/statistics/manager/request/stats', {
          type: this.category,
          user: this.user,
          date_begin: this.dateRange.startDate,
          date_end: this.dateRange.endDate,
        }).then((response) => {
          let datas = response.data;
          datas.graph.forEach((data) => {
            this.columnChart.series.push({
              name: data.name,
              data: data.data
            })
          })

          this.columnChart.chartOptions.xaxis.categories = datas.days
          this.$vs.loading.close()
          this.loading = false;
        }).catch((error) => {
          this.$vs.loading.close()
          this.loading = false;
          console.log(error)
        })
      },
      async exportStats() {
        this.$vs.loading()
        await axios({
          url: '/statistics/manager/request/stats/export',
          method: 'POST',
          data: {
            type: this.category,
            user: this.user,
            date_begin: this.dateRange.startDate,
            date_end: this.dateRange.endDate
          },
          responseType: 'blob',
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'statsManager.xlsx')
          document.body.appendChild(link)
          link.click()
          this.$vs.loading.close()
        }).catch((error) => {
          this.error_base = error.response.data.errors
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      getRequest(page) {
        this.$vs.loading()
        let info = {
          page: page,
          type: this.category,
          user: this.user,
          date_begin: this.dateRange.startDate,
          date_end: this.dateRange.endDate,
        }
        this.$http.get('/statistics/manager/request/list' + this._buildQuery(info)).then((response) => {
          this.requests = response.data.data
          this.last_page = response.data.last_page
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
  .bar {
    border-left: 1px solid #626262;
    height: 350px;
    opacity: 0.2;
  }
</style>
